import { useNotificationScanner } from './use-notification-scanner';

/**
 * 只負責跑掃描的隔離元件，避免通知輪詢造成 App Shell 重新 render。
 */
export function NotificationScanner({ onOpenTask }: { onOpenTask?: (taskId: string) => void }) {
  useNotificationScanner(onOpenTask);
  return null;
}
